import _, { isNil } from 'lodash';

export const toTitleCase = (text: string) => {
  return text.replace(
    /\w\S*/g,
    (word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()
  );
};

const isAllWhitespace = (str: string) => {
  return str.trim() === '';
};

export const isNilString = (text?: string) => {
  return _.isEmpty(text) || isNil(text) || isAllWhitespace(text);
};

export const safeImage = (str?: string) => {
  let src = undefined;

  if (str && !str.startsWith('data:image/png;base64,')) {
    src = 'data:image/png;base64,' + str;
  } else if (str) {
    src = str;
  }

  return src;
};

export const snakeCaseToWords = (str: string) =>
  _.words(str).map(_.toLower).map(_.capitalize).join(' ');

export const fuzzySearch = (searchText: string, query: string) => {
  const searchLower = searchText.toLowerCase();
  const queryLower = query.toLowerCase();

  let searchIndex = 0;
  for (let queryChar of queryLower) {
    searchIndex = searchLower.indexOf(queryChar, searchIndex);
    if (searchIndex === -1) return false;
    searchIndex += 1;
  }
  return true;
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (email?: string) => {
  if (!email) {
    return false;
  }

  return emailRegex.test(email);
};

const urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;

export const validateUrl = (url?: string) => {
  if (!url) {
    return false;
  }

  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    return false;
  }

  return urlRegex.test(url);
};

const linkedInRegex =
  /^(https?:\/\/)?(www\.)?linkedin\.com\/(?:in\/|profile\/view\?id=|pub\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]+\/)([a-zA-Z0-9_-]+)(\?.*)?$/;

export const validateLinkedInProfileURL = (url?: string) => {
  if (!url) {
    return false;
  }

  return linkedInRegex.test(url);
};

export const validateEmailDomain = ({
  email,
  website,
}: {
  email: string;
  website: string;
}) => {
  const emailDomain = email.split('@')[1];

  const _websiteDomain = website.replace(/^(https?:\/\/)?(www\.)?/, ''); // Remove protocol and 'www'
  const websiteDomain = _websiteDomain.split('/')[0]; // Remove any path after the domain

  if (!emailDomain || !websiteDomain) {
    return false;
  }
  return emailDomain.endsWith(websiteDomain);
};

export const formatMoney = (val: number | string) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(Number(val));
};

export const validatePhone = (phone?: string) => {
  if (!phone) {
    return false;
  }

  // Basic validation for US phone numbers (10 digits)
  const phoneRegex = /^\d{10}$/;
  return phoneRegex.test(phone.replace(/\D/g, '')); // Remove non-digit characters
}
